const doc = [({"da":({"js":({"admin":({"highscore_generations":({"overall_highscore":({"export_csv":"Eksporter CSV"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;